interface DashboardGreetingProps {
  name: string;
}

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "Good morning";
  if (hour >= 12 && hour < 17) return "Good afternoon";
  if (hour >= 17 && hour < 21) return "Good evening";
  return "Hey";
}

export function DashboardGreeting({ name }: DashboardGreetingProps) {
  const greeting = getGreeting();

  return (
    <h1 className="text-2xl font-semibold tracking-tight">
      {greeting}, {name}
    </h1>
  );
}
